import { render, staticRenderFns } from "./shopmanagement.vue?vue&type=template&id=648cab3d&scoped=true"
import script from "./shopmanagement.vue?vue&type=script&lang=ts"
export * from "./shopmanagement.vue?vue&type=script&lang=ts"
import style0 from "./shopmanagement.vue?vue&type=style&index=0&id=648cab3d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648cab3d",
  null
  
)

export default component.exports